<section class="component-layer">
  <div class="d-flex filter-row">
    <div class="d-flex">
      <!-- Global Search -->
      <div class="keyword-search">
        <p-iconfield iconPosition="left" class="ml-auto">
          <p-inputicon>
            <mat-icon style="margin-top: -2px">
              {{ commonService.getIcon("Search") }}
            </mat-icon>
          </p-inputicon>
          <input
            pInputText
            type="text"
            placeholder="Search here"
            [(ngModel)]="globalSearchValue"
            class="search-room-table table-filter"
            (input)="onGlobalSearchChange($event)"
          />
        </p-iconfield>
      </div>

      <!-- Status Filter -->
      <div class="filter_status">
        <img
          class="filter_list_icon left-icon"
          src="/images/icons/door-01.svg"
          alt="status-icon"
        />

        <p-select
          class="table-filter status-select"
          [(ngModel)]="selectedStatus"
          [options]="statusList"
          optionLabel="label"
          optionValue="value"
          placeholder="Alert Status"
          [showClear]="true"
          (onChange)="onStatusChange()"
        >
        </p-select>
      </div>

      <!-- Date Range Filter -->
      <div class="filter_status">
        <img
          class="filter_list_icon left-icon"
          src="/images/icons/calendar.svg"
          alt="calendar-icon"
          (click)="datepicker.toggle()"
          style="width: 24px; height: 24px"
        />

        <p-datepicker
          #datepicker
          [(ngModel)]="selectedDateRange"
          placeholder="Date Range"
          selectionMode="range"
          [showClear]="true"
          [showIcon]="false"
          (onFocus)="onDatePickerFocus()"
          (ngModelChange)="onDateRangeChange($event)"
          (onClear)="dateReset()"
          [ngClass]="{
            'ng-invalid ng-dirty': showDateRangeError && isDateTouched,
          }"
        >
        </p-datepicker>

        <!-- Validation message -->
        <small
          class="text-danger"
          style="padding-left: 8px"
          *ngIf="showDateRangeError && isDateTouched"
        >
          Please select end date
        </small>
      </div>
    </div>

    <!-- Reset -->
    <div class="filter-reset" (click)="clear(dt2)">
      <img
        src="/images/icons/rotate-clockwise.svg"
        alt="Reset"
        class="reset-icon"
      />
      <span class="reset-text">Reset</span>
    </div>
  </div>

  <!-- Table -->
  <p-table
    #dt2
    [value]="allSmsLog"
    [paginator]="true"
    [rows]="limit"
    [totalRecords]="totalRecords"
    [lazy]="true"
    [loading]="loading"
    (onLazyLoad)="onPageChange($event)"
    responsiveLayout="scroll"
    [globalFilterFields]="['sentVia', 'message']"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>Date</th>
        <th style="width: 300px; max-width: 300px">Message</th>
        <th>Recipients</th>
        <th class="no-wrap">Sent Via</th>
        <th>Status</th>
        <th style="width: 150px">Action</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-smsLog>
      <tr>
        <td>{{ DateFormatterIso.format(smsLog.date) || "N/A" }}</td>
        <td
          class="message-col text-truncate"
          pTooltip="{{ smsLog.message }}"
          tooltipPosition="top"
        >
          {{ smsLog?.message }}
        </td>
        <td>{{ smsLog?.status?.total }}</td>
        <td>{{ smsLog?.sentVia }}</td>
        <td class="no-wrap">
          <span class="text-success me-2" style="font-weight: 500">
            Sent {{ smsLog?.status?.sent }}
          </span>
          -
          <span class="ms-2 text-danger" style="font-weight: 500">
            Failed {{ smsLog?.status?.failed }}
          </span>
        </td>

        <td>
          <div class="d-flex align-items-center gap-2">
            <!-- View Details -->
            <div
              class="d-flex align-items-center"
              (click)="openViewModal(smsLog)"
            >
              <img
                src="/images/icons/view-sms.svg"
                alt="view"
                width="24"
                height="24"
                class="me-2"
              />
              <span class="view-text view-action">View Details</span>
            </div>

            <!-- More menu -->
            <button mat-icon-button [matMenuTriggerFor]="actionMenu">
              <mat-icon style="color: var(--black-1) !important"
                >more_vert</mat-icon
              >
            </button>

            <mat-menu #actionMenu="matMenu" class="custom-menu">
              <button
                mat-menu-item
                (click)="resendAlert(smsLog.id)"
                [disabled]="smsLog.alertStatus === 'DELIVERED'"
              >
                <img src="/images/icons/clock-02.svg" width="18" class="me-2" />
                <span>Send Again</span>
              </button>

              <button mat-menu-item (click)="openDeleteModal(smsLog?.id)">
                <img
                  src="/images/icons/delete-sms.svg"
                  width="18"
                  class="me-2"
                />
                <span>Delete</span>
              </button>
            </mat-menu>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>

<div class="delete-overlays" *ngIf="isDeleteModalOpen">
  <div class="delete-container">
    <button class="close-btn" (click)="closeModal()">
      <img
        src="images/icons/cross.svg"
        alt="close"
        style="height: 24px; width: 24px"
      />
    </button>
    <i class="delete-icon" style="margin-bottom: 24px"
      ><img
        src="images/icons/red-delete.svg"
        alt=""
        style="height: 56px; width: 56px"
    /></i>

    <div class="delete-modal-body">
      <h2
        style="
          margin-bottom: 20px;
          font-weight: 600;
          font-size: 18px;
          color: var(--black-5);
          text-align: center;
          line-height: 1.3;
        "
      >
        Are you sure you want to delete this SMS Log ?
      </h2>
      <p
        style="
          margin-bottom: 12px;
          font-size: 14px;
          font-weight: 400;
          color: var(--balck-2);
          text-align: center;
        "
      >
        This action is permanent and can not be undone.
      </p>
    </div>
    <div class="delete-modal-footer">
      <button
        class="btn btn-secondary-cancel md"
        style="width: 120px; height: 56px"
        (click)="closeModal()"
      >
        Cancel
      </button>
      <button
        class="btn btn-primary-delete md"
        style="width: 120px; height: 56px"
        (click)="deleteBulkAlert()"
      >
        Delete
      </button>
    </div>
  </div>
</div>

<app-sms-modal
  [(drawerVisible)]="showSmsDrawer"
  [smsData]="selectedSms"
></app-sms-modal>
